import {RepositoryFactory} from '@/api/factory/repositoryFactory'
const CouponCode = RepositoryFactory.get('couponCode')

const state = {
  couponCodes: [],
  couponCode: {},
  selectCourse: {},
  count: 0,
}

const actions = {
  async fetchCouponCodes({commit, rootState}, params = {}) {
    const {log, ...restParams} = params
    const res = await CouponCode.fetch({
      ...restParams,
    })
    commit('setCouponCodes', res.data || [])
    const parentCoupon = rootState.couponCode.couponCode || {}
    if (params.type === 'children' && res.data && !log) {
      let newCoupon = []
      if(parentCoupon?.unlimited){
        const coupon = res.data[0]
        const students = coupon.student || []
        const bills = coupon.bill || []
        newCoupon = students.map((student) => {
          const matchedBill = bills.find((bill) => bill.student === student.id)
          return {
            ...coupon,
            student,
            bill: matchedBill,
            usedAt: matchedBill?.usedAt || null,
          }
        })
        console.log('first',newCoupon)
        if(parentCoupon.logs){
          const logs = Object.values(parentCoupon.logs).map(item => ({
            code: coupon.code,
            student:{email: item.email},
            usedAt: item.usedAt,
            status: 'pending'
          }))
          newCoupon = [
            ...logs,
            ...newCoupon
          ]
        }
      } else {
        newCoupon = res.data.map(item =>({
          ...item,
          student: item.student ? item.student[0] : {},
          bill: item.bill ? item.bill[0] : {},
        }))
      }
      console.log('res.data', res.data)
      console.log('newCoupon', newCoupon)
      commit('setCouponCodes', newCoupon)
    }
    return res.data
  },
  async countCouponCodes({commit}, params) {
    const res = await CouponCode.count(params)
    commit('setCountCoupon', res.data)
    return res.data
  },
  async fetchCouponCodeById({commit}, id) {
    const res = await CouponCode.fetchOne(`${id}?_populate=relation`)
    commit('setOneCouponCode', res.data)
    return res.data
  },
  async createCouponCode({commit, rootState}, data) {
    const res = await CouponCode.create({
      ...data,
      userId: rootState.auth.auth.userId,
    })
    commit('setCouponCode', res.data)
    return res.data
  },
  async deleteCouponCode({commit}, id) {
    await CouponCode.remove(id)
    return commit('removeCouponCode', id)
  },
  async updateCouponCode({commit}, {id, couponCode}) {
    const res = await CouponCode.update(id, couponCode)
    commit('setCouponCode', res.data)
    return res.data
  },
  selectCourse({commit}, course) {
    commit('setSelectCourse', course)
  },
}

const mutations = {
  setCouponCodes(state, couponCodes) {
    return (state.couponCodes = couponCodes)
  },
  setSelectCourse(state, course) {
    state.selectCourse = course
  },
  setCountCoupon(state, count) {
    state.count = count
  },
  removeCouponCode(state, id) {
    state.couponCodes = state.couponCodes.filter((code) => code.id !== id)
  },
  setCouponCode(state, newCouponCode) {
    state.couponCodes = state.couponCodes.map((couponCode) => {
      if (couponCode._id === newCouponCode._id) {
        return newCouponCode
      } else return couponCode
    })
    return state.couponCodes
  },
  setOneCouponCode(state, couponCode) {
    state.couponCode = couponCode
  },
}

const getters = {
  getCouponCodes: (state) => {
    return state.couponCodes.reverse()
  },
  getCouponCode: (state) => {
    return state.couponCode
  },
  getCountCouponCode: (state) => {
    return state.count
  },
  getSelectCourse: (state) => {
    return state.selectCourse
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
